
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eventsDetails",
      function () {
        return require("private-next-pages/eventsDetails.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eventsDetails"])
      });
    }
  